import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Theme pages
import Home from "../themes/theme-one";
import Portfolio from "../themes/portfolio";
import PortfolioSingle from "../themes/portfolio-single";
import BeyondJustWork from "../themes/beyondjustwork";
import ItaibaRetreat from "../themes/itaiba-retreat";
import FanaResort from "../themes/fanaresort";
import About from "../themes/about";
import Blog from "../themes/blog";
import BlogSingle from "../themes/blog-single";
import Contact from "../themes/contact";
import Thankyou from "../components/Miscellaneous/thankyou";
import CasaPalmira from "../themes/casapalmira";

const MyRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio-single" element={<PortfolioSingle />} />
        <Route path="/beyondjustwork" element={<BeyondJustWork />} />
        <Route path="/casapalmira" element={<CasaPalmira />} />
        <Route path="/itaiba-retreat" element={<ItaibaRetreat />} />
        <Route path="/fanaresort" element={<FanaResort />} /> 
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-single" element={<BlogSingle />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/thankyou" element={<Thankyou />} />
      </Routes>
    </Router>
  );
};

export default MyRoutes;
